// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__cltsQ","radioRow":"SimpleQuestionBuilderModal_radioRow__21M70"};